export const extractFilenameFromContentDisposition = (
  contentDisposition: string,
): string | null => {
  if (!contentDisposition) return null;
  // Check for UTF-8 encoded filename (filename*)
  const utf8FilenameMatch = contentDisposition.match(
    /filename\*\s*=\s*UTF-8''([^;]+)/i,
  );
  if (utf8FilenameMatch) {
    return decodeURIComponent(utf8FilenameMatch[1].trim());
  }

  // Fallback to standard filename
  const filenameMatch = contentDisposition.match(/filename=([^;]+)/i);
  if (filenameMatch) {
    return filenameMatch[1].trim().replace(/^"(.*)"$/, '$1'); // remove quotes if present
  }

  return null;
};

export const viewPdf = (data: any) => {
  try {
    const blob = data;
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Nedladdning av fil misslyckades:', error);
    throw error;
  }
};
